import { defineComponent as _defineComponent } from 'vue'

import {getCurrentInstance, onBeforeUnmount} from 'vue';
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";


const __default__ = {
    name: "HiddenBuddyListItem"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    username: {},
    buddyList: {}
  },
  setup(__props: any) {

let props = __props;

let instance = getCurrentInstance().proxy;
ClientUserdataStore.subscribe(props.username, props.buddyList, instance);

onBeforeUnmount(() => {
    ClientUserdataStore.unsubscribe(props.username, props.buddyList, instance);
});


return (_ctx: any,_cache: any) => {
  return null
}
}

})